import React, { Component } from "react";
import axios from "axios";
import compareValues from "./SortValue.js";
import CryptoJS from "crypto-js";
import config from "../../config/authConfig.js";

class MRCPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      PayrollMRCItemData: [],
      sessionId: "",
      mrccode: "",
      mrcname: "",
      isMandatory: false,
      selectedvalue: "",
      isLoaded: false,
    };
  }
  async componentDidMount() {
    var lsWWID_dec = "1461636";
    if (process.env.REACT_APP_WORKDAY_LOCAL_DEBUG != "Yes") {
      // const secretKeyforEncryption = config.encryptionkey;
      // const aliasWWIDName = config.aliasWWIDName;
      // var lsWWID = sessionStorage.getItem(aliasWWIDName);
      // var lsWWID_dec_bytes = CryptoJS.AES.decrypt(lsWWID, secretKeyforEncryption);
      // lsWWID_dec = JSON.parse(lsWWID_dec_bytes.toString(CryptoJS.enc.Utf8));
      const secretKeyforEncryption = config.encryptionkey;
      var lsWWID = localStorage.getItem("wwid");
      var lsWWID_dec_bytes = CryptoJS.AES.decrypt(
        lsWWID,
        secretKeyforEncryption
      );
      var lsWWID_dec = JSON.parse(lsWWID_dec_bytes.toString(CryptoJS.enc.Utf8)); //this will decrypt the encrypted value.
    }
    if (this.props.mrccode != "") {
      this.setState({
        mrccode: this.props.mrccode,
        mrcname: this.props.mrcName,
        selectedvalue: this.props.mrccode,
      });
    }
    if (this.props.mngwwid != "" && this.props.locationreferenceID != "") {
      await axios({
        method: "POST",
        url: process.env.REACT_APP_WORKDAY_API_URL + "getLEAndPayrollMRC",
        headers: {
          apiKey: process.env.REACT_APP_WORKDAY_API_KEY,
          clientKey: process.env.REACT_APP_WORKDAY_API_CLIENTKEY,
          "Content-Type": "application/json",
        },
        data: {
          managerWWID: this.props.mngwwid,
          locationCode: this.props.locationreferenceID,
          sessionID: this.props.sessionID,
          //"loggedInUserWWID" : '1461636'
          loggedInUserWWID: lsWWID_dec,
        },
      })
        .then((res) => {
          this.setState({
            PayrollMRCItemData: res.data.legalEntityList,
            sessionId: res.data.sessionId,
            isLoaded: true,
          });
        })
        .catch((error) => {
          //on error
          // alert("There is an error in API call mngid.");
        });
    } else {
    }
  }

  PayrollMRCData = (legalitemdata) => {
    if (legalitemdata.length > 0) {
      let payrollMRCData = legalitemdata
        .filter((it) => {
          return it.legalEntity.leCode == this.props.lecode;
        })
        .map((it) => {
          return it;
        });
      let payrollMRCDataSort = payrollMRCData[0].payrollMRCList.sort(
        compareValues("payrollMRCCode")
      );
      return payrollMRCDataSort.map((item) => (
        <li
          key={item.payrollMRCCode}
          value={item.payrollMRCCode}
          className={
            this.state.selectedvalue == item.payrollMRCCode
              ? "lilist select-search-box__row lelist changebgcolor"
              : "lilist select-search-box__row lelist"
          }
          onClick={(e) => {
            this.handleCheck(item.payrollMRCCode, item.payrollMRCName);
          }}
        >
          <span className="leradiospan">
            <input
              type="radio"
              name="radio"
              value={item.payrollMRCName}
              id={item.payrollMRCCode}
              checked={this.state.mrccode === item.payrollMRCCode}
              onChange={(e) => {
                this.handleCheck(item.payrollMRCCode, item.payrollMRCName);
              }}
            ></input>
          </span>
          <span className="mrctext" title={item.payrollMRCName}>
            {item.payrollMRCCode} - {item.payrollMRCName}
          </span>
        </li>
      ));
    }
  };

  handleCheck = (id, val) => {
    this.setState({ mrccode: id, mrcname: val, selectedvalue: id });
  };
  handlePayrollMRCData = () => {
    if (this.state.mrccode != "") {
      this.props.onclickPayrollMRCNext(
        this.state.mrccode,
        this.state.mrcname,
        this.state.sessionId
      );
      this.setState({ isMandatory: false, sessionId: this.props.sessionID });
    } else {
      this.setState({ isMandatory: true });
    }
  };
  handlePayrollMRCDataBack = () => {
    this.props.onclickpayrollMRCBack(this.state.sessionId);
  };
  render() {
    return (
      <div>
        {this.state.isLoaded ? (
          <div>
            <h4 className="listheader">
              Please select a recommended{" "}
              <span className="listheadertext">Payroll MRC:</span>
            </h4>
            <ul className="ulist">
              {this.PayrollMRCData(this.state.PayrollMRCItemData)}
              <li
                className={
                  this.state.selectedvalue == "noa"
                    ? "lenoneoftheabove changebgcolor"
                    : "lenoneoftheabove"
                }
                onClick={(e) => {
                  this.handleCheck("noa", "noa");
                }}
              >
                <span className="leradiospan">
                  <input
                    type="radio"
                    name="radio"
                    value="noa"
                    id="noa"
                    checked={this.state.mrccode === "noa"}
                    onChange={(e) => {
                      this.handleCheck("noa", "noa");
                    }}
                  ></input>
                </span>
                <span className="mrctext" title="None of the above">
                  {" "}
                  None of the above
                </span>
              </li>
            </ul>
          </div>
        ) : (
          <div className="dataLoader">Loading data please wait...</div>
        )}
        {this.state.isMandatory === true ? (
          <label className="MandatoryFields">
            Please select a recommended Payroll MRC
          </label>
        ) : (
          ""
        )}
        {this.state.isLoaded ? (
          <div className="last-column rowhead lebtn">
            <div className="nextbtn leback">
              {" "}
              <input
                type="submit"
                value="< Back"
                className="btncls"
                onClick={this.handlePayrollMRCDataBack}
              />
            </div>
            <div className="nextbtn lenext">
              {" "}
              <input
                type="submit"
                value="Next >"
                onClick={this.handlePayrollMRCData}
                className="btncls"
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default MRCPage;
